import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <div className="text-6xl font-bold text-gray-300 mb-4">404</div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        Page non trouvée
      </h1>
      <p className="text-gray-600 mb-6">
        La page que vous recherchez n'existe pas.
      </p>
      <Link to="/" className="btn-primary">
        Retour à l'accueil
      </Link>
    </div>
  )
}
